module.exports = __webpack_public_path__ + "static/media/symphysis.4760389d.png";